import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { PhoneCallIcon, CheckIcon } from 'lucide-react';
import { Badge } from '../../Badge';
const OUTCOMES: string[] = ['電話や問い合わせで、本業の手が止まらなくなる', '取りこぼしていた予約や相談を、24時間受けられる', '「いつも誰かが対応してくれる」安心感をお客様に'];
export function AboutServices() {
  const reduce = useReducedMotion();
  return <section id="about-service" className="w-full bg-white" data-id="element-30" data-mp="zwurzgeao1cj">
      <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6 sm:py-24" data-id="element-31" data-mp="vwkpwetmhv2y">
        <div className="grid items-center gap-12 lg:grid-cols-2" data-id="element-32" data-mp="r52pbrvihwii">
          <motion.div initial={reduce ? undefined : {
          opacity: 0,
          y: 18
        }} whileInView={reduce ? undefined : {
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-33" data-mp="r2pxmmzyc7s9">
            <Badge variant="sky" style={{
            color: '#74A7C9',
            backgroundColor: 'rgba(116, 167, 201, 0.15)',
            borderColor: 'rgba(116, 167, 201, 0.3)'
          }} className="border" data-id="element-34" data-mp="2frtebqu3nata">
              私たちのサービス
            </Badge>
            <h2 className="mt-4 font-heading text-2xl font-bold text-text sm:text-3xl" data-id="element-35" data-mp="2tsdvyjoa30l7">
              いちばんの困りごとに、
              <br className="hidden sm:block" data-id="element-36" data-mp="2ype3z04oudey" />
              「AI受付スタッフ」を。
            </h2>
            <p className="mt-5 text-base leading-relaxed text-text" data-id="element-37" data-mp="2kpuvg67yt024">
              OptiDSA
              が現在いちばん力を入れているのが、電話応対・問い合わせ対応・予約受付を肩代わりする「AI受付スタッフ」です。
              人手が足りない現場の負担を減らし、経営者が本業に集中できる時間を取り戻します。
            </p>
            <p className="mt-4 text-base leading-relaxed text-text" data-id="element-38" data-mp="19dlqoqjolq6y">
              あれもこれもと手を広げるのではなく、あなたの現場でいちばん効く一手に集中してご提案します。
            </p>
          </motion.div>

          <motion.div initial={reduce ? undefined : {
          opacity: 0,
          y: 18
        }} whileInView={reduce ? undefined : {
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} data-id="element-39" data-mp="3fyyigj8m6rch">
            <div className="rounded-2xl border border-border bg-surface-muted p-6 sm:p-8" data-id="element-40" data-mp="2na0zedwkwqio">
              <div className="flex items-center gap-3" data-id="element-41" data-mp="2ic989m3rd8fj">
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-deep-navy text-white" data-id="element-42" data-mp="2idu3zf1t6xez">
                  <PhoneCallIcon className="h-6 w-6" aria-hidden="true" data-id="element-43" data-mp="gkcyagx8o6mv" />
                </span>
                <div data-id="element-44" data-mp="p1d9gm9xhrt8">
                  <p className="font-heading text-lg font-bold text-text" data-id="element-45" data-mp="p1wu4aqyquay">
                    AI受付スタッフ
                  </p>
                  <p className="text-sm text-text-muted" data-id="element-46" data-mp="t1nr4w7326nx">メインサービス</p>
                </div>
              </div>
              <ul className="mt-6 space-y-3" data-id="element-47" data-mp="xu8htoup03n8">
                {OUTCOMES.map(o => <li key={o} className="flex items-start gap-3" data-id="element-48" data-mp="12rqjqvaalilq">
                    <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sage-green/15 text-sage-green" data-id="element-49" data-mp="62slv478x4kc">
                      <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-50" data-mp="a4mgovurfecl" />
                    </span>
                    <span className="text-sm leading-relaxed text-text" data-id="element-51" data-mp="f1w465yl9fxs">
                      {o}
                    </span>
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}